import React from 'react';
import { Clock as ClockIcon, ShoppingCart as CartIcon, Users as FamilyIcon } from 'lucide-react';
const ProblemSolution = () => {
  return <section className="py-16 bg-white" data-id="element-242">
      <div className="container mx-auto px-4" data-id="element-243">
        <div className="text-center mb-12" data-id="element-244">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800" data-id="element-245">
            El problema no es falta de tiempo ni de dinero… es la falta de
            organización y recetas prácticas.
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-246">
            Nuestro Método Exprés Latino te da las herramientas para transformar
            tus noches de semana en momentos deliciosos sin estrés, con recetas
            auténticas que puedes preparar en solo 30 minutos.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12" data-id="element-247">
          <div className="flex flex-col items-center text-center p-6 rounded-lg bg-amber-50" data-id="element-248">
            <div className="bg-custom-brown p-3 rounded-full mb-4" data-id="element-249">
              <ClockIcon size={28} className="text-white" data-id="element-250" />
            </div>
            <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-251">⏱ Rápido</h3>
            <p className="text-gray-600" data-id="element-252">
              Cenas completas en solo 30 minutos, para que puedas disfrutar más
              tiempo con tu familia.
            </p>
          </div>
          <div className="flex flex-col items-center text-center p-6 rounded-lg bg-amber-50" data-id="element-253">
            <div className="bg-custom-brown p-3 rounded-full mb-4" data-id="element-254">
              <CartIcon size={28} className="text-white" data-id="element-255" />
            </div>
            <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-256">
              🛒 Económico
            </h3>
            <p className="text-gray-600" data-id="element-257">
              Lista de compras optimizada para aprovechar ingredientes y ahorrar
              dinero cada semana.
            </p>
          </div>
          <div className="flex flex-col items-center text-center p-6 rounded-lg bg-amber-50" data-id="element-258">
            <div className="bg-custom-brown p-3 rounded-full mb-4" data-id="element-259">
              <FamilyIcon size={28} className="text-white" data-id="element-260" />
            </div>
            <h3 className="text-xl font-bold mb-2 text-gray-800" data-id="element-261">
              👨‍👩‍👧 Familiar
            </h3>
            <p className="text-gray-600" data-id="element-262">
              Recetas que encantan a todos, con opciones para adaptar a los
              gustos de cada miembro de la familia.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default ProblemSolution;